import useRouteQueryParams from "../../../../../common/hooks/use-route-query-params";
import OrderOptimizerListingRouteQueryParams from "../../../common/routes/types/order-optimizer-listing-route-params";
import OrderOptimizerRailyListingFilter from "../common/types/order-optimizer-raily-listing-filter";
import orderOptimizerRailyListingFiltersService from "./order-optimizer-raily-listing-filters.service";

const useOrderOptimizerRailyListingFiltersDao = () => {
  const [routeQueryParams, setRouteQueryParams] =
    useRouteQueryParams<OrderOptimizerListingRouteQueryParams>();

  const getPage = () => {
    return orderOptimizerRailyListingFiltersService.getPage(routeQueryParams);
  };

  const getPageSize = () => {
    return orderOptimizerRailyListingFiltersService.getPageSize(
      routeQueryParams
    );
  };

  const getFilters = (): OrderOptimizerRailyListingFilter[] => {
    return orderOptimizerRailyListingFiltersService.getFilters(
      routeQueryParams
    );
  };

  const saveFilters = (
    filters: OrderOptimizerRailyListingFilter[],
    page: number,
    pageSize: number
  ): void => {
    const routeQueryParams =
      orderOptimizerRailyListingFiltersService.createRouteQueryParams(
        filters,
        page,
        pageSize
      );

    setRouteQueryParams(routeQueryParams);
  };

  return {
    getPage,
    getPageSize,
    getFilters,
    saveFilters,
  };
};

export default useOrderOptimizerRailyListingFiltersDao;
